// extracted by mini-css-extract-plugin
export var childrenContainer = "_49-0";
export var virtualScrollArea = "_49-1";